import type { CustomFieldValue } from '@vy/custom-fields-types';
import { isNotEmptyString, isNullOrUndefined } from '@vy/utils';

export const isUsableCustomFieldValue = (entry: CustomFieldValue): boolean => {
  const { value } = entry;

  if (isNullOrUndefined(value)) {
    return false;
  }

  const trimmedValue = String(value).trim();

  return isNotEmptyString(trimmedValue);
};
